import { useEffect, useState } from "react";
import { faqList } from "@/mocks/manhwa";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-schema";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqList.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.getElementById("faq-schema")?.remove();
    };
  }, []);

  return (
    <section id="faq" className="mx-auto max-w-4xl px-4 py-16 md:px-6 md:py-20">
      <div className="text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-700">
          <i className="ri-question-line"></i> 帮你解答
        </span>
        <h2 className="mt-4 font-heading text-2xl font-black text-foreground-900 md:text-4xl">常见问题</h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
          关于榜单更新、评分机制与入坑选择，你关心的问题都在这里。
        </p>
      </div>

      <div className="mt-10 space-y-3">
        {faqList.map((item, idx) => {
          const open = openIdx === idx;
          return (
            <div
              key={item.q}
              className={`overflow-hidden rounded-2xl border transition-colors ${
                open ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-100/60"
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenIdx(open ? -1 : idx)}
                className="flex w-full items-center justify-between gap-3 p-4 text-left md:p-5"
                aria-expanded={open}
              >
                <h3 className="flex-1 text-sm font-semibold text-foreground-900 md:text-base">{item.q}</h3>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-transform ${
                    open ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  <i className="ri-add-line"></i>
                </span>
              </button>
              {open && (
                <div className="border-t border-background-200 px-4 pb-5 pt-3 md:px-5">
                  <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}